export function RplBadge({ className = '' }: { className?: string }) {
  return (
    <span
      className={`inline-flex w-fit rounded-full bg-violet-50 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-violet-800 ring-1 ring-inset ring-violet-200 ${className}`}
    >
      RPL
    </span>
  );
}
